import React, { useState } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import Avatar from '../../components/ui/Avatar';
import { actionLogs, employees, stores } from '../../data/mockData';
import { Search } from 'lucide-react';

const typeLabels = { scan: 'Сканирование', osg_check: 'ОСГ проверка', display_complete: 'Выкладка', photo_upload: 'Фото-отчёт', task_accept: 'Принята задача', task_cancel: 'Отмена' };
const typeBadge = { scan: 'primary', osg_check: 'osg', display_complete: 'display', photo_upload: 'success', task_accept: 'in_progress', task_cancel: 'error' };

export default function ActionLog() {
  const [search, setSearch] = useState('');
  const [filterType, setFilterType] = useState('');

  const enriched = actionLogs.map(l => ({
    ...l,
    employeeName: employees.find(e => e.id === l.employeeId)?.name || l.employeeId,
    storeName: stores.find(s => s.id === l.storeId)?.name || l.storeId,
  }));

  const filtered = enriched.filter(l => {
    if (search && !l.employeeName.toLowerCase().includes(search.toLowerCase()) && !(l.product || '').toLowerCase().includes(search.toLowerCase())) return false;
    if (filterType && l.type !== filterType) return false;
    return true;
  });

  const columns = [
    { key: 'timestamp', label: 'Дата/время', render: v => <span style={{ fontSize: 12, color: '#6B7280', whiteSpace: 'nowrap' }}>{new Date(v).toLocaleString('ru-RU')}</span> },
    {
      key: 'employeeName', label: 'Сотрудник',
      render: (v, row) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar name={v} size={28} />
          <span style={{ fontWeight: 500, whiteSpace: 'nowrap' }}>{v}</span>
        </div>
      )
    },
    { key: 'storeName', label: 'Магазин', render: v => <span style={{ fontSize: 12, color: '#6B7280' }}>{v}</span> },
    { key: 'type', label: 'Тип', render: v => <Badge variant={typeBadge[v] || 'gray'}>{typeLabels[v] || v}</Badge> },
    { key: 'description', label: 'Описание', render: v => <span style={{ fontSize: 12 }}>{v}</span> },
    { key: 'product', label: 'Товар', render: v => <span style={{ fontSize: 12, color: '#374151' }}>{v || '—'}</span> },
    { key: 'result', label: 'Результат', render: v => <Badge variant={v === 'success' ? 'success' : 'error'}>{v === 'success' ? 'Успешно' : 'Ошибка'}</Badge> },
    { key: 'photo', label: 'Фото', sortable: false, render: v => v ? <span style={{ fontSize: 18 }}>🖼️</span> : '—' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1A2E' }}>Журнал действий</h1>
        <p style={{ color: '#8E8E93', fontSize: 13, marginTop: 2 }}>Все действия сотрудников в мобильном приложении</p>
      </div>
      <Card padding="0">
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #F3F4F6', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#F5F6FA', borderRadius: 8, padding: '7px 12px', flex: 1, minWidth: 200 }}>
            <Search size={14} color="#9CA3AF" />
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Поиск..." style={{ border: 'none', background: 'transparent', outline: 'none', fontSize: 13, width: '100%', fontFamily: 'inherit' }} />
          </div>
          <select value={filterType} onChange={e => setFilterType(e.target.value)} style={{ padding: '7px 12px', border: '1px solid #E5E7EB', borderRadius: 8, fontSize: 13, background: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>
            <option value="">Все типы</option>
            {Object.entries(typeLabels).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>
        <Table columns={columns} data={filtered} emptyText="Нет действий" />
      </Card>
    </div>
  );
}
